import { render, staticRenderFns } from "./brfooter.vue?vue&type=template&id=28719bd5&scoped=true&"
import script from "./brfooter.vue?vue&type=script&lang=js&"
export * from "./brfooter.vue?vue&type=script&lang=js&"
import style0 from "./brfooter.vue?vue&type=style&index=0&id=28719bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28719bd5",
  null
  
)

export default component.exports